module.exports = {
    BASE_URL: "https://mas.ift.world/v2/"
}
